import { isValidElement, useEffect, useState } from 'react';
import {
  ActiveStep,
  AnimateCheck,
  Step,
  Steps,
  WhiteOverlay,
} from './commonStyle';
import { Check } from '@phosphor-icons/react';

interface ISingleStepperProps {
  step: {
    stepText: React.ReactNode;
    render: React.ReactNode;
  };
  play: number;
}

export function SingleStepper({ step, play }: ISingleStepperProps) {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (play > 0) {
      playAnimation();
    }
  }, [play]);

  const playAnimation = () => {
    setAnimate(true);
    setTimeout(() => {
      setAnimate(false);
    }, 1000);
  };

  return (
    <div className="sk:w-full sk:h-full sk:relative single-stepper">
      <Steps>
        <Step active={1} className="sk:w-full single-stepper">
          {isValidElement(step.stepText) ? (
            step.stepText
          ) : (
            <span className="active">{step.stepText}</span>
          )}
        </Step>
      </Steps>
      <ActiveStep>{step.render}</ActiveStep>
      {animate && (
        <AnimateCheck>
          <Check size={60} />
          <WhiteOverlay />
        </AnimateCheck>
      )}
    </div>
  );
}
